import React from "react";
import { HiOutlineMap } from "react-icons/hi";

import DoSeeListPage from "../../../layout/DoSeeListPage";
import { _TYPES_ } from "../utils/types";
import { pushOneGettingAround } from "../../../lib/sysNavigation/SysNavigation";

type GettingAroundRow = {
  getting_around_id: number | string;
  title?: string;
  slug?: string;
  [key: string]: unknown;
};

const Overview: React.FC = () => (
  <DoSeeListPage<GettingAroundRow>
    type={_TYPES_.GETTINGAROUND}
    title="Getting Around"
    subtitle="Transportation entries listed on the public site."
    icon={<HiOutlineMap className="h-5 w-5" />}
    addRoute="/data/get/around/add"
    editRoute="/data/get/around/edit"
    pushOne={pushOneGettingAround}
    dataKey="gettingArounds"
    countKey="gettingAroundsCount"
    idField="getting_around_id"
  />
);

export default Overview;
